/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Land_SizeInputs */

const en_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land Size`)
};

const es_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño del terreno`)
};

const fr_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille du terrain`)
};

const de_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundstücksgröße`)
};

const ja_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敷地面積`)
};

const zh_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地面积`)
};

const ar_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مساحة الأرض`)
};

const id_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luas Tanah`)
};

const it_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensioni Terreno`)
};

const ru_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадь участка`)
};

const pt_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho do Lote`)
};

const ko_land_size = /** @type {(inputs: Land_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대지 면적`)
};

/**
* | output |
* | --- |
* | "Land Size" |
*
* @param {Land_SizeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const land_size = /** @type {((inputs?: Land_SizeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Land_SizeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_land_size(inputs)
	if (locale === "es") return es_land_size(inputs)
	if (locale === "fr") return fr_land_size(inputs)
	if (locale === "de") return de_land_size(inputs)
	if (locale === "ja") return ja_land_size(inputs)
	if (locale === "zh") return zh_land_size(inputs)
	if (locale === "ar") return ar_land_size(inputs)
	if (locale === "id") return id_land_size(inputs)
	if (locale === "it") return it_land_size(inputs)
	if (locale === "ru") return ru_land_size(inputs)
	if (locale === "pt") return pt_land_size(inputs)
	return ko_land_size(inputs)
});